import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/approved-vendors/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
